import * as ICONS from 'ionicons/icons';

// Constants
import { APP_CONFIG } from '../constants';

// Validators
import { AppValidator } from '../validators';
import { isWeb } from './extract-config.helper';
import { saveMainteinment, loadMainteinment } from './storage.helper';

export const statusTransactionHandler = (transactionStatus) => {

    const status = transactionStatus || 500;
    const mapStatus = APP_CONFIG.API.VIRTUAL_CREDENTIAL.STATUS_CODE_TRANSACTION[status];

    return {
        status,
        description: mapStatus ? mapStatus.DESCRIPTION : '',
        color: mapStatus ? mapStatus.COLOR : '',
        icon: mapStatus ? ICONS[mapStatus.ICON] : ''
    };
};

export const checkStateApp = (setShowModal, history) => {

    // Si la aplicación está en mantenimiento, muestra el modal
    const mainteinment = AppValidator.AppIsMainteinment();
    if (mainteinment.enabled) {

        // Si es Web, redirecciona a la sección de mantenimiento
        if ( isWeb() ) {

            saveMainteinment(true);
            history.replace(APP_CONFIG.PAGES.MAINTEINMENT.path);
        }

        setShowModal({ show: true, title: mainteinment.title, message: mainteinment.message });   
    }
    else {

        // Sólo si es Web, debo evitar redirigir en casos en que ya no estaba la app en mantenimiento
        // Si no se hace, cada vez que se hace foco en la app, me vuelve al inicio
        const isMainteinment = loadMainteinment();
        if ( isWeb() && isMainteinment ) {
            
            saveMainteinment(false);
            history.replace('/');
        }
        
        setShowModal({ show: false, title: mainteinment.title, message: mainteinment.message });
    }
}